"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
var OrgHierarchyService = /** @class */ (function () {
    // @todo, these dependencies are provided by angular (see below), eventually find another way to set these
    function OrgHierarchyService(
    // @ts-ignore
    http, 
    // @ts-ignore
    $q, 
    // @ts-ignore
    API_ROUTES, 
    // @ts-ignore
    env, 
    // @ts-ignore
    loggerService) {
        this.http = http;
        this.$q = $q;
        this.API_ROUTES = API_ROUTES;
        this.env = env;
        this.loggerManager = loggerService.getLoggerManager('orgHierarchyService');
    }
    OrgHierarchyService.prototype.isOrgHierarchyFilter = function (filter) {
        var ORGH_FILTER_PREFIXES = ['Q_Units', 'Q_PrimaryUnits'];
        var field = lodash_1.default.get(filter, 'filter.field');
        return lodash_1.default.some(ORGH_FILTER_PREFIXES, function (prefix) {
            return lodash_1.default.startsWith(field, prefix);
        });
    };
    OrgHierarchyService.prototype.getOrgHierarchyFilterViewForUnits = function (unitIds, filters) {
        var _this = this;
        if (!unitIds) {
            throw new Error('orgHierarchyService: No unit Id passed');
        }
        if (!filters) {
            throw new Error('orgHierarchyService: No filters passed');
        }
        var url = this.API_ROUTES.DATA_FILTERING_SERVICE + "/getOrgHierarchyFilterView";
        var orgHierarchyId = this.getOrgId();
        // fieldsetId as the outermost key when sending filters to pr
        var fieldsetId = Object.keys(filters)[0];
        var httpOptions = {
            options: { unitIds: unitIds, filters: filters },
            orgHierarchyId: orgHierarchyId,
            fieldsetId: fieldsetId
        };
        // @ts-ignore
        return this.http.post(url, httpOptions).then(function (response) {
            return response.data;
            // @ts-ignore
        }).catch(function (error) {
            _this.loggerManager.error("Could not get OrgHierarchyFilterView for units " + unitIds, error);
        });
    };
    OrgHierarchyService.prototype.getOrgUnits = function (unitIds) {
        var _this = this;
        if (!unitIds) {
            // this is needed in case js caller calls this function with a falsy value
            // this check won't be needed when we can assume all callers are in typescript
            throw new Error('orgHierarchyService: No unit Id passed');
        }
        unitIds = lodash_1.default.isArray(unitIds) ? unitIds : [unitIds];
        return this.$q.all(unitIds.map(function (unitId) {
            var url = _this.API_ROUTES.ORG_HIERARCHY_SERVICE + "/getUnit/" + unitId;
            // Use promise chaining because angular does not support
            // mocking http requests with await/async
            return _this.http.get(url, {
                cache: true
                // @ts-ignore
            }).then(function (response) {
                return response.data;
                // @ts-ignore
            }).catch(function (error) {
                console.error('Could not get unit info for', unitId, error);
            });
        }));
    };
    OrgHierarchyService.prototype.getOrgId = function () {
        var _a;
        return (_a = this.getPrivateExportContextMeta()) === null || _a === void 0 ? void 0 : _a.activeOrgHierarchyId;
    };
    OrgHierarchyService.prototype.getOrgUnitIds = function () {
        var _a;
        return (_a = this.getPrivateExportContextMeta()) === null || _a === void 0 ? void 0 : _a.activeUnitId;
    };
    OrgHierarchyService.prototype.getPageFilters = function () {
        var _a;
        return (_a = this.getPrivateExportContextMeta()) === null || _a === void 0 ? void 0 : _a.pageFilterDefinitions;
    };
    OrgHierarchyService.prototype.getPrivateExportContextMeta = function () {
        if (!this.privateExportContextMeta) {
            this.privateExportContextMeta = this.env.get('privateExportContextMeta');
            if (lodash_1.default.isString(this.privateExportContextMeta)) {
                // should be a stringified json
                try {
                    this.privateExportContextMeta = JSON.parse(this.privateExportContextMeta);
                }
                catch (error) {
                    this.loggerManager.error('Could not parse privateExportContext');
                    // set to empty object to avoid logging the same error
                    this.privateExportContextMeta = {};
                }
            }
            if (!lodash_1.default.isEmpty(this.privateExportContextMeta)) {
                // remove privateExportContextMeta logs since it contains filters which may have PII
                // TODO: reintroduce filter logs with operand redacted https://qualtrics.atlassian.net/browse/REP-8261
                // this.loggerManager.info({
                // 	privateExportContextMeta: this.privateExportContextMeta
                // });
            }
        }
        return this.privateExportContextMeta;
    };
    OrgHierarchyService.$inject = [
        '$http',
        '$q',
        'pr.API_ROUTES',
        'rsEnvironment',
        'pr.loggerService'
    ];
    return OrgHierarchyService;
}());
(function (module) {
    module.service('pr.orgHierarchyService', OrgHierarchyService);
})(angular_1.module('qualtrics.pr'));
